import React, { useEffect } from "react";
import "./Notification.scss";
import { ReactComponent as NotificationOpen } from "../../../assets/svg/notificationOpen.svg";
import { ReactComponent as NotificationReceived } from "../../../assets/svg/notificationReceived.svg";
import { useTranslation } from "react-i18next";
import { useNotification } from "../../../hooks/useNotification";
import DefaultLayout from "../../components/Layouts/DefaultLayout";

function Notification() {
  const { notifications, loading, markNotificationsAsRead } = useNotification(); // Usando o contexto
  const { t } = useTranslation();

  useEffect(() => {
    // Função de limpeza que será chamada ao sair da página (componente desmontado)
    return () => {
      if (notifications.length > 0) {
        // Marca as notificações como lidas apenas quando o componente for desmontado
        markNotificationsAsRead();
      }
    };
  }, [notifications, markNotificationsAsRead]); // Chama quando as notificações mudam

  if (loading) {
    return <div className="loading">{t("loading")}</div>;
  }

  return (
    <DefaultLayout>
      <section className="notification">
        <div className="container">
          <h2>{t("notification-title-1")}</h2>
          <ul>
            {notifications.length === 0 ? (
              <li>{t("notification-none")}</li>
            ) : (
              notifications.map((notification, index) => (
                <li key={index} className="row">
                  {notification.isRead === 1 ? <NotificationOpen /> : <NotificationReceived />}
                  <div className="column">
                    {notification.isRead === 1 ? (
                      <p className="read">{notification.title}</p>
                    ) : (
                      <p className="unread">{notification.title}</p>
                    )}
                    <span>{notification.datatime}</span>
                  </div>
                </li>
              ))
            )}
          </ul>
        </div>
      </section>
    </DefaultLayout>
  );
}

export default Notification;
